export default __webpack_public_path__ + "static/media/fish1.73c79f80.jpeg";